export const readableDate = (date_in_string, removeTime) => {
    const currentDate = new Date(date_in_string);
    // console.log(date_in_string)
    // Array of month names
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Get the date components
    const year = currentDate.getFullYear();
    const monthIndex = currentDate.getMonth();
    const day = currentDate.getDate().toString().padStart(2, '0');

    // Get the time components
    const hours = currentDate.getHours().toString().padStart(2, '0');
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    if(removeTime === true){
    // Create a readable date string with the month name
    return `${monthNames[monthIndex]} ${day}, ${year}`

    }else{
    // Create a readable date and time string with the month name
    return `${monthNames[monthIndex]} ${day}, ${year}.   ${hours}:${minutes}`;
    }

}


export const getTimeZoneDate = (isoString) => {

  if (!isoString) return null;

  try {
    // Create date object from ISO string
    const dateObject = new Date(isoString);

    // Check if date is valid
    if (isNaN(dateObject.getTime())) {
      throw new Error('Invalid date format');
    }

    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZoneName: 'long'
    };

    const formedDate = new Intl.DateTimeFormat('en-US', options).format(dateObject)
    return String(formedDate)

  } catch (error) {
    // console.error('Error parsing date:', error);
    return 'Invalid date format';
  }
};


const moment = require('moment-timezone');

export const convertDateTime = (dateTimeStr, timezone) => {
  const dt = moment.tz(dateTimeStr, timezone);
  return dt.format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ');
}

export const extractTime = (isoTimestamp) => {
  const date = new Date(isoTimestamp);

  // Get hours, minutes in local time
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  // Format as HH:MM
  return `${hours}:${minutes}`;
}
